module.exports = __webpack_public_path__ + "static/media/komb-is-correct.a653e585.mp3";